import { FC } from 'react';

import { ResponseError } from './ErroServidor.utils';
import { MensagensErrosDeNegocioServidor } from './MensagensErrosDeNegocioServidor';
import { MensagemErroServidorRede } from './MensagemErroServidorRede';


export interface MensagensErroServidorProps {
  retry?: () => void
  erro?: ResponseError
  className?: string;
}


export const MensagensErroServidor: FC<MensagensErroServidorProps> = ({erro, retry, className}) => {
  if (erro === undefined) {
    return <></>
  }

  const tituloPadrao = "Caro usuário, ocorreram os seguintes erros:";
  const erroDeRede = erro.status === undefined;

  if (erroDeRede) {
    return <MensagemErroServidorRede erro={erro} retry={retry} className={className} />

  } else if (erro.status === 401){
    const erroAtualizado = gerarMensagemCustomizada(erro, tituloPadrao, `Falha no processo de autenticação de usuário: ${erro.data?.message ?? "Tente se logar no sistema novamente." }` );
    return <MensagensErrosDeNegocioServidor erro={erroAtualizado} className={className} />
  } else if (erro.status === 403){
    const erroAtualizado = gerarMensagemCustomizada(erro, tituloPadrao, `Falha no processo de autorização do recurso: ${erro.data?.message ?? "Operação não autorizada."}`);
    return <MensagensErrosDeNegocioServidor erro={erroAtualizado} className={className} />
  } else if (erro.status === 404) {
    const erroAtualizado = gerarMensagemCustomizada(erro, tituloPadrao, 'Não foi possível acessar esse recurso. Ele não existe ou você não possui permissão para visualização.');
    return <MensagensErrosDeNegocioServidor erro={erroAtualizado} className={className} />
    
  } else if (erro.status === 409) {
    return <MensagensErrosDeNegocioServidor erro={erro} />
    
  } else if (erro.status === 502) {
    const erroAtualizado = gerarMensagemCustomizada(erro, tituloPadrao, 'O sistema está em atualização, por favor tente em instantes.');
    return <MensagensErrosDeNegocioServidor erro={erroAtualizado} className={className} />

  } else if (erro.status === 503) {
    const erroAtualizado = gerarMensagemCustomizada(erro, "Não foi possível realizar esta operação", erro.data?.message ?? "Tente novamente mais tarde");
    return <MensagensErrosDeNegocioServidor erro={erroAtualizado} className={className} />
  
  } else {
    const erroAtualizado = gerarMensagemCustomizada(erro, tituloPadrao, 'Não foi possível realizar esta operação. Por favor tente novamente.');
    return <MensagensErrosDeNegocioServidor erro={erroAtualizado} className={className} />
  }
}


function gerarMensagemCustomizada(erro: ResponseError, titulo: string, detalhes: string): ResponseError {
  return {
    ...erro,
    data: {
      message: titulo,
      details: [{message: detalhes}]
    }
  }
}
